/**
 * Calculates the final price based on type and input value.
 * 
 * @param {number} originalPrice - The original base price.
 * @param {number} value - The value to apply, depending on the type.
 * @param {'amount' | 'discount' | 'rate'} type - The type of calculation to apply.
 * @returns {number} - The calculated final price.
 */
export function calculateByType(originalPrice, value, type) {

  switch (type) {
    case 'amount':
      return value;

    case 'discount':
      return originalPrice * (1 - value/100);

    case 'rate':
      return originalPrice / value;

    default:
      return value
  }
}

const calculatePrice = (data, operation, prevData) => {
  const {  originField, originValue, priceType, targetField } = operation

  const originalPrice = data[originValue]
  const type = data[priceType]
  const value = data[originField]

  let netSalePrice = calculateByType(originalPrice, value, type)

  // Return new object instead of mutating
  return {
    ...data,
    [targetField]: netSalePrice
  }
}

export default calculatePrice
